module.exports = __webpack_public_path__ + "static/media/burger-lunch.40a3a3da.jpg";